import React from 'react';
import cn from 'classnames';
import { XCircle, Check, X } from 'react-feather';
import { Spinner } from 'ui';
import { Text, TEXT_VARIANTS, TEXT_COLORS } from '../Typography';

const Chip = ({
  value,
  onClick,
  ariaLabel,
  isLoading,
  isDisabled,
  variant,
  size,
  iconLeft,
  customClassName,
}) => {
  const chipClassName = cn(
    'Chip d-f ai-c jc-sb',
    {
      'Chip-disabled': isDisabled || isLoading,
      'Chip-default': variant === 'default',
      'Chip-error': variant === 'error',
      'Chip-success': variant === 'success',
    },
    customClassName,
  );

  const variants = [
    { name: 'success', textColor: TEXT_COLORS.SUCCESS_DARK },
    { name: 'error', textColor: TEXT_COLORS.ERROR_DARK },
    { name: 'default', textColor: TEXT_VARIANTS.TAG_BOLD },
  ];

  const colorPicker = () => {
    const matchedColor = variants.filter(
      v => v.name === variant && v.textColor,
    );
    return matchedColor[0].textColor;
  };

  const chipBody = () => {
    return (
      <Text
        variant={
          size === 'small'
            ? TEXT_VARIANTS.TAG_BOLD
            : TEXT_VARIANTS.INSTRUX_SEMIBOLD
        }
        color={colorPicker()}
        className="text-wrap"
      >
        {value}
      </Text>
    );
  };

  return (
    <div className={chipClassName}>
      {iconLeft ? (
        <div className="d-f ai-c jc-sb">
          {iconLeft === 'check' ? (
            <Check size={size === 'small' ? 18 : 22} className="mr-4" />
          ) : (
            <X size={size === 'small' ? 18 : 22} className="mr-4" />
          )}
          {chipBody()}
        </div>
      ) : (
        <>{chipBody()}</>
      )}
      {isLoading && <Spinner className="Chip-Spinner" />}{' '}
      {onClick && !isLoading && (
        <button
          disabled={isDisabled}
          aria-label={ariaLabel}
          type="button"
          onClick={onClick}
          className="Chip-XCircle"
        >
          <XCircle
            size={18}
            className={cn({
              'Chip-XCircle-Icon': !isDisabled,
            })}
          />
        </button>
      )}
    </div>
  );
};

export default Chip;
